import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/NotFound.css';
import bearImage from '../assets/404-bear.png';
import LiveChatWidget from '../components/livechat/LiveChatWidget';

const NotFound = () => {
  const handleLiveChatClick = () => {
    alert('Live chat coming soon!');
  };

  return (
    <div className="notfound-container">
      <img
        src={bearImage}
        alt="Bear holding a map with X"
        className="notfound-image animate-float"
      />

      <h1 className="notfound-title">Ooops! Page Not Found</h1>
      <p className="notfound-description">
        The page you’re looking for might have been moved or no longer exists.
      </p>

      <div className="notfound-links">
        <Link to="/" className="btn-primary">← Go to KuddleBoard</Link>
        <a href="mailto:support@kuddlecore.com" className="btn-outline">Contact Support</a>
        <button onClick={handleLiveChatClick} className="btn-outline">Live Chat</button>
      </div>

      <LiveChatWidget />
    </div>
  );
};

export default NotFound;
